import type { ReactElement } from 'react'
import type { AvatarComponentType } from '../avatar'
import type { HyperlinkComponentType } from '../hyperlink'
import type { NamedIconComponentType } from '../icon'
import type { IconBlobComponentType } from '../icon-blob'
import type { IllustrationBlobComponentType } from '../illustration-blob'

export enum BannerStyle {
  neutral = 'neutral',
  positive = 'positive',
  critical = 'critical',
  warning = 'warning',
  marketing = 'marketing',
  loyalty = 'loyalty',
  primary = 'primary',
}

type BannerStyleType = `${BannerStyle}`
export interface BannerProps {
  accessory?:
    | IllustrationBlobComponentType
    | AvatarComponentType
    | IconBlobComponentType
    | ReactElement<NamedIconComponentType>
  className?: string
  style?: BannerStyleType
  title?: string
  description: string
  link?: HyperlinkComponentType
}
